import * as React from 'react'
import type { SVGProps } from 'react'
import { Ref, forwardRef } from 'react'

interface SVGRProps {
  title?: string
  titleId?: string
}
const ArrowRightIcon = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={42}
    height={42}
    viewBox="0 0 42 42"
    fill="none"
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      d="M27.95 20.7463C27.9182 20.6645 27.8706 20.5898 27.8099 20.5265L24.4752 17.1959C24.413 17.1338 24.3392 17.0845 24.2579 17.0509C24.1767 17.0173 24.0896 17 24.0017 17C23.8241 17 23.6537 17.0705 23.5281 17.1959C23.4659 17.258 23.4166 17.3317 23.383 17.4129C23.3493 17.494 23.332 17.581 23.332 17.6688C23.332 17.8462 23.4025 18.0164 23.5281 18.1418L25.729 20.3333H15.6669C15.4901 20.3333 15.3204 20.4035 15.1953 20.5284C15.0703 20.6533 15 20.8228 15 20.9994C15 21.1761 15.0703 21.3455 15.1953 21.4704C15.3204 21.5954 15.4901 21.6655 15.6669 21.6655H25.729L23.5281 23.8571C23.4656 23.919 23.416 23.9927 23.3821 24.0738C23.3483 24.155 23.3309 24.2421 23.3309 24.33C23.3309 24.418 23.3483 24.505 23.3821 24.5862C23.416 24.6674 23.4656 24.741 23.5281 24.803C23.5901 24.8654 23.6639 24.915 23.7452 24.9488C23.8264 24.9826 23.9136 25 24.0017 25C24.0897 25 24.1769 24.9826 24.2582 24.9488C24.3394 24.915 24.4132 24.8654 24.4752 24.803L27.8099 21.4724C27.8706 21.409 27.9182 21.3343 27.95 21.2526C28.0167 21.0904 28.0167 20.9085 27.95 20.7463Z"
      fill="white"
    />
  </svg>
)
const ForwardRef = forwardRef(ArrowRightIcon)
export { ForwardRef as ReactComponent }
